import { useEffect, useState } from 'react';
import { useForm } from '../forms/useForm';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getAllThermometers, createThermometers, updateThermometers, deleteThermometers } from './micThermometer';

export const useMicThermometer = () => {

    const [loading, setLoading] = useState(false);
    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate,sweetDeleteBacterium1,sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal,sweetAcceptGlobal] = useSweetAlert();

    const [visible, setVisible] = useState(false);
    const [method, setMethod] = useState("");
    const [listThermometers, setListThermometers] = useState([]);
    const [searchThermometers, setSearchThermometers] = useState([]);


    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        id_thermometer: 0,
        name_thermometer: "",
        abbreviation: "",
        internal_thermometer: "",
        correction_factor: ""
    });

    const { id_thermometer, name_thermometer, abbreviation, internal_thermometer, correction_factor } = formValues;

    const [validaciones, setValidaciones] = useState({
        name_thermometer: false,
        abbreviation: false,
        correction_factor: false,
        
    });

    const loadThermometers = async () => {
        setLoading(true);
        const data = await getAllThermometers();
        setListThermometers(data);
        setSearchThermometers(data);
        setLoading(false);
    };

    useEffect(() => {
        loadThermometers();
    }, []);

    const handleCreate = () => {
        handleUpdateValues({
            name_thermometer: "",
            abbreviation: "",
            internal_thermometer: "",
            correction_factor: "",
        
        });    
        setMethod("create");
        setVisible(true);

    }

    const saveCreateThermometer = async (e) => {
        e.preventDefault();

        setLoading(true);

          if (validarForm()) {
            createSweet("error", "error", "Error", "Completa todos los campos obligatorios antes de guardar");
            setLoading(false);
        return;
}

        const thermometer = {
            id_thermometer,
            name_thermometer,
            abbreviation,
            internal_thermometer,
            correction_factor
        };

        const response = await createThermometers(thermometer);

        if (response) {
            setLoading(false);
            createSweet("success", "success", "Se creó correctamente el termómetro");
            setVisible(false);
            loadThermometers();

        } else {
            setLoading(false);
            createSweet("warning", "warning", "No se generó correctamente el corte");
        }
    };


    const saveUpdateThermometers = async (e) => 
    {
        e.preventDefault();
        setLoading(true);

        if (validarForm()) {
            createSweet("error", "error", "Error", "Completa todos los campos obligatorios antes de guardar");

            setLoading(false);
        return;
}


        const response = await updateThermometers({
            id_thermometer: id_thermometer,
            name_thermometer: formValues.name_thermometer,   
            abbreviation: formValues.abbreviation,   
            internal_thermometer: formValues.internal_thermometer,   
            correction_factor: formValues.correction_factor,  

        });

        if (response.code === 200){
                setLoading(false);
                createSweet("success", "success", "Se a actualizado correctamente");
                setVisible(false);
                loadThermometers();

            handleUpdateValues({
                name_thermometer:"",
                abbreviation: "",
                internal_thermometer:"",
                correction_factor: ""


            })
        } 
    }

    const handleUpdate = (thermometer) => {
        handleUpdateValues({
            id_thermometer: thermometer.id_thermometer,
            name_thermometer: thermometer.name_thermometer,
            abbreviation: thermometer.abbreviation,
            internal_thermometer: thermometer.internal_thermometer,
            correction_factor: thermometer.correction_factor
        });
        setMethod("update");
        setVisible(true);
    };


    const handleDelete = async (thermometer) => {
        const confirmDelete = await sweetAcceptGlobal(
            "¿Eliminar Termómetro?",
            `¿Estás seguro de eliminar el termómetro "${thermometer.name_thermometer}"?`,
            "warning",
            true
        );

        if (confirmDelete) {
            const result = await deleteThermometers({
                id_thermometer: thermometer.id_thermometer
            });

            if (result.code === 200) {
                createSweet("success", "success", "Termómetro eliminado correctamente");
                loadThermometers();

                setVisible(false);
            } else {                                    
                createSweet("error", "error", "Termómetro", "No se eliminó correctamente");

            }
        }


       
    };

    
    const validarForm = () => {
        let statusValidacion = false;
        let newValidaciones = {};

        if (formValues.name_thermometer.trim().length <= 2) {
            newValidaciones.name_thermometer = true;
            statusValidacion = true;
        } else {
            newValidaciones.name_thermometer = false;
        }

        if (formValues.abbreviation.trim().length <= 1) {
            newValidaciones.abbreviation = true;
            statusValidacion = true;
        } else {
            newValidaciones.abbreviation = false;
        }

        if (formValues.correction_factor === "" || isNaN(formValues.correction_factor)) {
            newValidaciones.correction_factor = true;
            statusValidacion = true;
        } else {
            newValidaciones.correction_factor = false;
        }

        setValidaciones(prev => ({
            ...prev,
            ...newValidaciones
        }));

        return statusValidacion;
    };

    const handleSearchThermometer = (e) => {
        let busqueda = e.target.value.trim();
        let newMethod = [];
        const safeToUpper = (value) => (typeof value === "string" ? value.toUpperCase() : "");

        if (busqueda === "") {
            setListThermometers(searchThermometers); 
            return;
        }

        searchThermometers.forEach(element => {
            let name_thermometer = safeToUpper(element.name_thermometer);
            let abbreviation = safeToUpper(element.abbreviation);

            if ((name_thermometer.indexOf(busqueda.toUpperCase()) > -1) || (abbreviation.indexOf(busqueda.toUpperCase()) > -1)) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });

        setListThermometers(newMethod);
    };


    return {
        visible, setVisible, handleInputChange, handleCreate, saveCreateThermometer, handleUpdate, saveUpdateThermometers,
        loading, setLoading, method,handleDelete, listThermometers, formValues, handleSearchThermometer
    };


}




